// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"SectionHeader-module__SectionHeader___1bgeH","prime":"SectionHeader-module__prime___1TvQM"};